import React from 'react';
import { componentService } from 'js/services/component.service';

export const UrlTemplateLink = React.lazy(() => import(/* webpackChunkName: "url-template-link" */ './UrlTemplateLink'));

// <hub2-url-template-link name="pop_history" target="window|_self|_blank">Show Game History</hub2-url-template-link>
componentService.registerWebContentComponents({ UrlTemplateLink });
